import * as RequestState from '../../requestStates/RequestState';
export const getDataFetchingClientRequestState = (error, loading) => loading ? RequestState.PENDING : error ? RequestState.FAILED : RequestState.SUCCEEDED;